const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const formatCurrencyNumber = (number = 0, numberFormat = USDollar) => numberFormat.format(number);

const formatDecimalNumber = (number = 0) => new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: number >= 1 ? 0 : 2,
  maximumFractionDigits: number >= 1 ? 0 : 2,
}).format(number);

const formatTrashieCashNumber = (number = 0, className = '') => (
  <p className={className}>
    T
    <sup>$</sup>
    {` ${Number(number).toFixed(2)}`}
  </p>
);

const transactionTypes = {
  withdraw: 1,
  deposit: 2,
};

const isNegativeTransaction = (transactionType) => transactionType === transactionTypes.withdraw;

const getTransactionAmount = (amount, transactionType) => {
  switch (transactionType) {
    case transactionTypes.withdraw:
      return amount * -1;
    case transactionTypes.deposit:
    default:
      return amount;
  }
};

const formatReadableNumber = (number = 0) => {
  const decimalPart = number - Math.floor(number);
  const roundedNumber = decimalPart <= 0.55 ? Math.floor(number) : Math.ceil(number);

  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(roundedNumber);
};

const formatQuantity = (quantity) => {
  const thousand = 1000;
  const million = 1000000;
  const billion = 1000000000;
  const safeQuantity = Number.isFinite(Number(quantity)) ? Number(quantity) : 0;

  let value = safeQuantity;
  let suffix = '';

  if (safeQuantity >= thousand && safeQuantity < million) {
    value = safeQuantity / thousand;
    suffix = 'K';
  }

  if (safeQuantity >= million && safeQuantity < billion) {
    value = safeQuantity / million;
    suffix = 'M';
  }

  if (safeQuantity > billion) {
    value = safeQuantity / million;
    suffix = 'B';
  }

  value = parseFloat(value.toFixed(1));

  if (value % 1 === 0) {
    value = parseFloat(value.toFixed(0));
  } else if (!suffix) {
    value = Math.ceil(value);
  }

  return { value, suffix };
};

const formatTcCreditText = (amount, type, { withBack = false } = {}) => {
  const value = Number(amount) || 0;
  const suffix = withBack ? ' back' : '';
  if (type === 'PERCENTAGE') return `Earn ${formatReadableNumber(value * 100)}%${suffix}`;
  if (type === 'VALUE') return `Earn $${formatReadableNumber(value)}${suffix}`;
  return 'Earn TC';
};

export {
  formatCurrencyNumber,
  formatTrashieCashNumber,
  getTransactionAmount,
  isNegativeTransaction,
  formatQuantity,
  formatDecimalNumber,
  formatReadableNumber,
  formatTcCreditText,
};
